import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const PhaseOutLazy = lazyLoader(
  () => import('./PhaseOut' /* webpackChunkName: "phase-out" */),
);

const PhaseOut = () => {
  return (
    <Suspense fallback={null}>
      <PhaseOutLazy />
    </Suspense>
  );
};

export default PhaseOut;
